import React from 'react';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import Button from '@mui/material/Button';
import SwitchComponent from '../Device-settings/Switch.component';
import useDictionary from '@ui/hooks/useDictionary';
import { IProps as IMainProps } from './IProps';
import { emptyFn } from '@core/interfaces/emptyFn';

interface IProps
    extends Pick<
        IMainProps,
        | 'columnVisibilityModel'
        | 'onToggleCol'
        | 'onShowAllCol'
        | 'onHideAllCol'
    > {
    open: boolean;
    anchorEl: HTMLDivElement | null;
    onClose: emptyFn;
}

const Component: React.FC<IProps> = ({
    open,
    anchorEl,
    columnVisibilityModel,
    onClose,
    onToggleCol,
    onShowAllCol,
    onHideAllCol,
}: IProps) => {
    const getWord = useDictionary();
    const switchItems = Object.keys(columnVisibilityModel).map((key) => (
        <Box className="column-menu__item" component="li">
            <SwitchComponent
                classes={{
                    root: 'column-menu__switch',
                    labelWrap: 'column-menu__switch-label',
                }}
                alarmState={columnVisibilityModel[key]}
                name={key}
                onAlarmStateChange={onToggleCol}
                key={key}
            />
        </Box>
    ));

    return (
        <Menu open={open} anchorEl={anchorEl} onClose={onClose}>
            <Box className="column-menu__wrap">
                <Button className="column-menu__btn" onClick={onShowAllCol}>
                    {getWord('showAll')}
                </Button>
                <Button className="column-menu__btn" onClick={onHideAllCol}>
                    {getWord('hideAll')}
                </Button>
                <Box className="column-menu__list">{switchItems}</Box>
            </Box>
        </Menu>
    );
};

const VisibleMenuComponent = React.memo(Component);

export default VisibleMenuComponent;
